/* eslint-disable camelcase */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { languagecodevalue, openSnackbar} from '../../store/reducer';
import trialAndStripeSubscriptionService from '../../services/trialAndStripeSubscriptionService';
import helper from '../../utils/helper';

export default function SatCard(props) {
  const { satDetails, allSatDetails } = props;
  const isNotSubscribed = props.data?.ispaid === false && props.data?.is_payment === true;
  const userRole = useSelector((state) => state.userInfo?.role);
  const allcourseDetails = useSelector((state) => state);
  const userInfo = useSelector((state) => state.userInfo);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [currency] = useState(userInfo?.currencyType?.code || 'USD');
  const [intfrequency] = useState(1);
  const [viewPrice, setViewPrice] = useState(0);

  const convertComplexity = (level) => {
    const complexityMap = {
      easy: 'Beginner',
      medium: 'Intermediate',
      hard: 'Advanced'
    };
    return complexityMap[level?.toLowerCase()] || level;
  };

  const assessmentType = useMemo(() => {
    const { is_free: isFree, is_payment: isPayment, ispaid } = props.data || {};
    if (isPayment === true) {
      return 'PAID';
    }
    if (isFree === true || (isPayment === false && ispaid === false)) {
      return 'FREE';
    }
  }, [props.data]);

  const isPaidAssessment = assessmentType === 'PAID';

  const isExpired = useMemo(() => {
    // if (!props.data?.valid_from || !props.data?.valid_to) return false;
    const { valid_from, valid_to } = props.data || {};

    if (!valid_from || !valid_to || valid_from === valid_to) {
      return false;
    }
    const today = new Date();
    const fromDate = new Date(props.data.valid_from);
    const toDate = new Date(props.data.valid_to);

    return today < fromDate || today > toDate;
  }, [props.data?.valid_from, props.data?.valid_to]);
  

  const attemptsData = useMemo(() => {
    const attempts = props.data?.attempts;
    const rawCount = attempts === null || attempts === undefined ? 0 : attempts.length;
    const clonedAssessmentCount =props.data?.clonedAssessment?.length 
    if (isPaidAssessment) {
      const displayCount = rawCount;
      const hasNoAttempts = rawCount === 0;
      const hasOnlyFreeAttempt = rawCount === 1;
      const allAttemptsUsed = rawCount >= 6;
      const hasFreeAttemptRemaining = rawCount === 0 && props.data?.ispaid === false;

      const isPurchased = props.data?.is_payment === true && props.data?.ispaid === true

      return {
        display: displayCount,
        total: 6,
        hasNoAttempts,
        hasOnlyFreeAttempt,
        allAttemptsUsed,
        showProgressBar: isPurchased || rawCount > 0, 
        showFreeAttemptBadge: hasFreeAttemptRemaining,
        hasFreeAttemptRemaining
      };
    }
    return {
      clonedAssessment:clonedAssessmentCount,
      display: rawCount,
      total: 5,
      hasNoAttempts: rawCount === 0,
      hasOnlyFreeAttempt: false,
      allAttemptsUsed: rawCount >= 5,
      showProgressBar: attempts !== null && rawCount > 0,
      showFreeAttemptBadge: false,
      hasFreeAttemptRemaining: false
    };
  }, [props.data?.attempts, isPaidAssessment, props.data?.ispaid, props.data?.is_payment, props.data?.subscription_status]);

  const priceDisplay = useMemo(() => {
    const { is_payment: isPayment, ispaid, subscription_status: subscriptionStatus } = props.data || {};

    const isPurchased = isPayment === true &&
      ispaid === true &&
      subscriptionStatus !== 'DELETED' &&
      subscriptionStatus !== 'CANCELED';

    const shouldShowPrice = (isPayment === true && ispaid === false) ||
      (isPayment === true &&
        ispaid === true &&
        (subscriptionStatus === 'DELETED' || subscriptionStatus === 'CANCELED'));

    if (isPurchased) {
      return { text: '', color: 'text-[#B3254D]', isPurchased: true };
    }
    if (shouldShowPrice) {
      return { text: viewPrice, color: 'text-[#B3254D]', isPurchased: false };
    }
    return { text: 'FREE', color: 'text-[#249935]', isPurchased: false };
  }, [props.data, viewPrice]);

  const statusBadges = useMemo(() => {
    const badges = [];
    const { is_payment: isPayment, ispaid, subscription_status: subscriptionStatus } = props.data || {};

    if (isPaidAssessment && attemptsData.hasNoAttempts && !priceDisplay.isPurchased) {
      badges.push({
        text: '1 Free Attempt',
        bgColor: 'bg-blue-100',
        textColor: 'text-blue-700'
      });
    }
    if (isPaidAssessment && attemptsData.hasNoAttempts && priceDisplay.isPurchased  && !isExpired) {
      badges.push({
        text: '1 Free Attempt Remains',
        bgColor: 'bg-blue-100',
        textColor: 'text-blue-700'
      });
    }

      if (!isExpired && priceDisplay.isPurchased){
      badges.push({
        text: 'Purchased',
        bgColor: 'bg-pink-100',
        textColor: 'text-[#B3254D]'
      });
    }

    if (isPaidAssessment && !ispaid && !attemptsData.hasNoAttempts) {
      badges.push({
        text: ' Free Attempts Exhausted',
        bgColor: 'bg-pink-100',
        textColor: 'text-[#B3254D]'
      });
    }
    if (!isPaidAssessment) {
      badges.push({
        text: '5 Free Attempts',
        bgColor: 'bg-green-100',
        textColor: 'text-[#249935]'
      });
    }

     if (isPaidAssessment && isExpired) {
       badges.push({
       text: 'Expired',
       bgColor: 'bg-red-500',
       textColor: 'text-white'
      });
     }

    if (attemptsData.allAttemptsUsed) {
      badges.push({
        text: 'Attempts Exhausted',
        bgColor: 'bg-red-500',
        textColor: 'text-white'
      });
    }

    return badges;
  }, [isPaidAssessment, priceDisplay.isPurchased, isExpired, attemptsData, props.data]);
  const buttonConfig = useMemo(() => {
  const { is_payment: isPayment,ispaid,subscription_status: subscriptionStatus} = props.data || {};
 
  const attemptsLen = props.data?.attempts?.length ?? 0;

  const isPaid = isPayment === true;
  const isFree = isPayment === false;
  const isPurchased =  isPaid && ispaid === true && subscriptionStatus !== "DELETED" && subscriptionStatus !== "CANCELED";

  const isNotPurchased = isPaid && !isPurchased;
  const maxAttempts = isPaid ? 6 : 5;
  // if (isExpired) {
  //   return {
  //     text: "Renew Assessment",
  //     bgColor: "bg-red-500",
  //     hoverColor: "hover:bg-red-600",
  //     textColor: "text-white",
  //     action: "renew",
  //   };
  // }

 if (attemptsLen >= maxAttempts) {
  const hasClonedAssessment = attemptsData.clonedAssessment?.length > 0;

  return {
    text:  props.data?.cloned_assessment > 0 ? "Buy Again" : "View Analysis",
    bgColor: "bg-blue-600",
    hoverColor: "hover:bg-blue-700",
    textColor: "text-white",
    action: props.data?.cloned_assessment > 0 ? "buyAgain" : "viewAttempted",
  };
}

  if (isFree) {
    return {
      text: attemptsLen === 0 ? "View More" : "Continue Your Test",
      bgColor: "bg-blue-600",
      hoverColor: "hover:bg-blue-700",
      textColor: "text-white",
      action: attemptsLen === 0 ? "view" : "start",
    };
  }

  if (isNotPurchased) {
    return {
      text: "View Details",
      bgColor: "bg-blue-600",
      hoverColor: "hover:bg-blue-700",
      textColor: "text-white",
      action: "view",
    };
  }

  return {
    text: attemptsLen === 0 ? "Start Your Test" : "Continue Your Test",
    bgColor: "bg-blue-600",
    hoverColor: "hover:bg-blue-700",
    textColor: "text-white",
    action: "start",
  };
}, [props.data]);

  useMemo(() => {
    const filteredList = props.data?.stripe_pricing_list?.filter((data) =>
      allcourseDetails?.currency === 'USD'
        ? data?.related_currency_type_lk === 2
        : data?.related_currency_type_lk === 1
    );

    let displayPrice;
    if (filteredList?.length > 0) {
      const priceValue = filteredList[0].value;
      displayPrice = allcourseDetails?.currency === 'USD'
        ? `$${priceValue}`
        : `₹${priceValue}`;
    } else {
      displayPrice = 'NAN';
    }

    setViewPrice(displayPrice);
  }, [allcourseDetails, props.data?.stripe_pricing_list]);

  const handleClickTrialButton = async (planId, enrollmentType, assessmentId, details) => {
    setLoading(true);
    const body = {
      name: details.title,
      description: details.short_description,
      SATtype: details.type,
      level: convertComplexity(details.complexity_level)
    };

    try {
      const res = await trialAndStripeSubscriptionService.postTrialAssessmentEnrollmentDetails(
        JSON.stringify({
          planId,
          enrollmentType,
          assessmentId,
          authUserId: userInfo.id,
          body
        })
      );

      if (res.ok) {
        dispatch(openSnackbar(`Subscribed to ${details?.title} Successfully.`));
        handleStartSat();
      }
    } catch (error) {
      console.error('Trial enrollment error:', error);
    } finally {
      setLoading(false);
    }
  };

  const postAssessmentSubscriptionDetails = async () => {
    let impactClickId = '';

    try {
      impactClickId = await helper.getClickId();
    } catch (error) {
      console.error('Click ID error:', error);
    }

    const payload = {
      userId: userInfo.id,
      courseId: props.data?.id,
      planId: props.data?.subscriptionplanid || satDetails?.subscriptionplanid,
      currencyType: currency,
      frequency: parseInt(intfrequency, 10),
      impactClickId,
      type: 'assessment'
    };

    try {
      const res = await trialAndStripeSubscriptionService.createAssessmentSubscription(
        JSON.stringify(payload)
      );

      if (res.status === 303) {
        window.location = res.data.paymentUrl;
      } else {
        dispatch(openSnackbar(res.data.message));
      }
    } catch (error) {
      console.error('Subscription error:', error);
    }
  };

  const handleButtonClick = () => {
      handleStartSat();
  };

const handleStartSat = () => {
  const encodedTitle = encodeURIComponent(props?.data?.title);
  const routePath = userRole === 'AUTH_USER' 
    ? `/app/assessment/${encodedTitle}/${props?.data?.id}` 
    : `/auth/assessment/${encodedTitle}/${props?.data?.id}`;

  dispatch(languagecodevalue('en'));
  navigate(routePath, {
    state: {
      id: props?.data?.id,
      from: 'SAT',
      data: props?.data,
      allSatDetails
    }
  });
};

  const backgroundUrl = props.data?.image_name;

  const handleUpgradeClick = () => {
    const plansPath = userRole === 'AUTH_USER' ? '/app/plans' : '/auth/plans';
    navigate(plansPath, {
      state: {
        id: props?.data?.id,
        satDetails: allSatDetails,
        from: 'card'
      }
    });
  };

  const title = props.data?.title || 'Untitled Assessment';

  return (
<div className="w-full h-[420px] rounded-xl shadow-lg overflow-hidden bg-white transition-all duration-300 hover:shadow-xl flex flex-col">    {/* IMAGE */}
    <button
      onClick={handleStartSat}
      // className="relative w-full h-[180px] bg-gradient-to-br from-purple-600 to-purple-700 overflow-hidden group flex-shrink-0"
      className="relative w-full h-[175px] bg-gradient-to-br from-purple-600 to-purple-700 overflow-hidden group flex-shrink-0"
      type="button"
    >
      {props.data?.image_name ? (
        <img
          src={props.data?.image_name}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
      ) : (
        <div className="w-full h-full bg-gray-200" />
      )}
    </button>

    {/* CONTENT */}
    <div className="p-4 flex flex-col flex-1">
      {/* TITLE */}
      <div className="relative h-[52px] mb-1">
        <h3
          className="text-lg font-bold text-gray-900 leading-snug line-clamp-2"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          {title}
        </h3>

        {showTooltip && title.length > 40 && (
          <div className="absolute left-0 top-full mt-1 w-max max-w-[300px] bg-gray-900 text-white text-sm px-3 py-2 rounded-md shadow-lg z-50">
            {title}
          </div>
        )}
      </div>

      {/* BADGES */}
      <div className="flex items-center gap-2 mb-2 min-h-[24px] flex-wrap">
                {statusBadges.map((badge, index) => (
          <span
            key={index}
            className={`text-[10px] ${badge.bgColor} ${badge.textColor} px-2 py-1 rounded-full font-medium`}
          >
            {badge.text}
          </span>
        ))}
      </div>

      {/* ATTEMPTS */}
      <div className="min-h-[20px] mb-1">
                <p className="text-sm text-gray-600">
          No of Attempts:{' '}
          {attemptsData.total === 6 ? '06' : '05'}
        </p>
      </div>

      {/* PROGRESS BAR SPACE RESERVED */}
      <div className="min-h-[42px] mb-2 flex items-end">
                {attemptsData.showProgressBar &&
          (priceDisplay.isPurchased ||
            !isPaidAssessment) && (
            <div className="w-full">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs text-gray-600 font-medium">
                  Attempts
                </span>

                <span className="text-xs text-gray-600">
                  {attemptsData.display}/
                  {attemptsData.total} used
                </span>
              </div>

              <div className="flex gap-1">
                {[...Array(attemptsData.total)].map(
                  (_, index) => (
                    <div
                      key={index}
                      className={`flex-1 h-2 rounded-full ${
                        index < attemptsData.display
                          ? 'bg-green-500'
                          : 'bg-gray-200'
                      }`}
                    />
                  )
                )}
              </div>
            </div>
          )}
      </div>

      {/* BUTTONS */}
      <div className="mt-auto">
        {isNotSubscribed ? (
          <div className="flex gap-2">
            <button
              onClick={handleButtonClick}
              disabled={loading}
              className={`flex-1 py-2.5 rounded-lg font-semibold text-sm transition-all
              ${buttonConfig.bgColor}
              ${buttonConfig.textColor}
              ${buttonConfig.hoverColor}
              shadow-sm hover:shadow-md`}
              type="button"
            >
              {loading
                ? 'Loading...'
                : buttonConfig.text}
            </button>

            <button
              onClick={handleUpgradeClick}
              type="button"
              className="flex-1 py-3 rounded-lg font-semibold text-sm transition-all border-2 border-gray-300 bg-white text-gray-700 hover:bg-gray-50 shadow-sm hover:shadow-md"
            >
              Upgrade
            </button>
          </div>
        ) : (
          <button
            onClick={handleButtonClick}
            disabled={loading}
           className={`w-full py-2.5 rounded-lg  font-semibold text-sm transition-all
            ${buttonConfig.bgColor}
            ${buttonConfig.textColor}
            ${buttonConfig.hoverColor}
            shadow-sm hover:shadow-md`}
            type="button"
          >
            {loading
              ? 'Loading...'
              : buttonConfig.text}
          </button>
        )}
      </div>
    </div>
  </div>
//     <div className={`w-full rounded-xl shadow-lg overflow-hidden bg-white transition-all duration-300 hover:shadow-xl flex flex-col ${isNotSubscribed ? 'h-[410px] sm:h-[430px]' : 'h-[360px] sm:h-[380px]'}`}>
//       <button
//         onClick={handleStartSat}
//         className="relative w-full h-[140px] sm:h-[160px] bg-gradient-to-br from-purple-600 to-purple-700 cursor-pointer flex items-center justify-center overflow-hidden group flex-shrink-0"
//         type="button"
//         aria-label={`View ${title}`}
//       >
//         {backgroundUrl ? (
//           <img
//             src={backgroundUrl}
//             alt={title}
//             className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
//           />
//         ) : (
//           <svg className="w-12 h-12 sm:w-14 sm:h-14 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
//           </svg>
//         )}
//       </button>

//       <div className="p-3 sm:p-4 flex flex-col flex-1 min-h-0">
//         <div className="relative mb-2 min-h-[48px]">
//           <h3
//             className="text-sm sm:text-base md:text-lg font-bold text-gray-900 leading-snug line-clamp-2 cursor-default"
//             onMouseEnter={() => setShowTooltip(true)}
//             onMouseLeave={() => setShowTooltip(false)}
//           >
//             {title}
//           </h3>

//           {showTooltip && title.length > 40 && (
//             <div className="absolute left-0 top-full mt-1 w-max max-w-[300px] bg-gray-900 text-white text-sm font-medium px-3 py-2 rounded-md shadow-lg z-[9999] whitespace-normal break-words">
//               {title}
//               <div className="absolute -top-1 left-3 w-2 h-2 bg-gray-900 rotate-45" />
//             </div>
//           )}
//         </div>

//         <div className="flex items-center gap-1.5 mb-2 h-[22px] sm:h-[24px] flex-wrap">
//           {statusBadges.map((badge, index) => (
//             <span
//               key={index}
//               className={`text-[9px] sm:text-[10px] ${badge.bgColor} ${badge.textColor} px-2 py-0.5 rounded-full font-medium whitespace-nowrap`}
//             >
//               {badge.text}
//             </span>
//           ))}
//         </div>

//         <div className="flex items-start justify-between mb-2 h-[20px] sm:h-[22px]">
//           <p className="text-[10px] sm:text-xs text-gray-600 whitespace-nowrap">
//             No of Attempts: {attemptsData.total === 6 ? '06' : '05'}
//           </p>
//         </div>

//         <div className={`${attemptsData.showProgressBar && (priceDisplay.isPurchased||!isPaidAssessment) ? 'h-[44px] mb-2' : 'h-0 mb-0'}`}>
//           {attemptsData.showProgressBar && (priceDisplay.isPurchased||!isPaidAssessment) && (
//             <div>
//               <div className="flex items-center justify-between mb-1.5">
//                 <span className="text-[9px] sm:text-[10px] text-gray-600 font-medium">Attempts</span>
//                 <span className="text-[9px] sm:text-[10px] text-gray-600">
//                   {attemptsData.display}/{attemptsData.total} used
//                 </span>
//               </div>
//               <div className="flex gap-1 sm:gap-1.5">
//                 {[...Array(attemptsData.total)].map((_, index) => (
//                   <div
//                     key={index}
//                     className={`flex-1 h-1 sm:h-1.5 rounded-full transition-all duration-300 ${index < attemptsData.display ? 'bg-green-500' : 'bg-gray-200'
//                       }`}
//                   />
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
// <div className="mt-auto pt-1.5">
//   {isNotSubscribed ? (
//     // BOTH BUTTONS -> SAME ROW
//     <div className="flex gap-2">
//       <button
//         onClick={handleButtonClick}
//         disabled={loading}
//         className={`flex-1 py-2 sm:py-2.5 rounded-lg font-semibold text-xs sm:text-sm transition-all
//           ${buttonConfig.bgColor} ${buttonConfig.textColor} ${buttonConfig.hoverColor}
//           shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed`}
//         type="button"
//       >
//         {loading ? 'Loading...' : buttonConfig.text}
//       </button>

//       <button
//         onClick={handleUpgradeClick}
//         type="button"
//         className="flex-1 py-2 sm:py-2.5 rounded-lg font-semibold text-xs sm:text-sm transition-all border-2 border-gray-300 bg-white text-gray-700 hover:bg-gray-50 shadow-sm hover:shadow-md"
//       >
//         Upgrade to Access
//       </button>
//     </div>
//   ) : (
//     // SINGLE BUTTON -> FULL WIDTH
//     <button
//       onClick={handleButtonClick}
//       disabled={loading}
//       className={`w-full py-2 sm:py-2.5 rounded-lg font-semibold text-xs sm:text-sm transition-all
//         ${buttonConfig.bgColor} ${buttonConfig.textColor} ${buttonConfig.hoverColor}
//         shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed`}
//       type="button"
//     >
//       {loading ? 'Loading...' : buttonConfig.text}
//     </button>
//   )}
// </div>
//         {/* <div className="mt-auto pt-1.5">
//           <button
//             onClick={handleButtonClick}
//             disabled={loading}
//             className={`w-full py-2 sm:py-2.5 rounded-lg font-semibold text-xs sm:text-sm transition-all
//                        ${buttonConfig.bgColor} ${buttonConfig.textColor} ${buttonConfig.hoverColor} 
//                        shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed`}
//             type="button"
//           >
//             {loading ? 'Loading...' : buttonConfig.text}
//           </button>
//           {isNotSubscribed && (
//             <button
//               onClick={handleUpgradeClick}
//               type="button"
//               className="w-full mt-2 py-2 sm:py-2.5 rounded-lg font-semibold text-xs sm:text-sm transition-all border-2 border-gray-300 bg-white text-gray-700 hover:bg-gray-50 shadow-sm hover:shadow-md"
//             >
//               Upgrade to Access
//             </button>
//           )}
//         </div> */}
//       </div>
//     </div>
  );
}